import { t } from "i18next";
import store from "../store/index";
import BMOEnglish from "../assets/agreementFiles/BMO-English.pdf";
import BMOFrench from "../assets/agreementFiles/BMO-French.pdf";
import {url} from "../constants/url.constants";
import BNSEnglish from "../assets/agreementFiles/BNS-English.pdf";
import BNSFrench from "../assets/agreementFiles/BNS-French.pdf";

import CIBCEnglish from "../assets/agreementFiles/CIBC-English.pdf";
import CIBCFrench from "../assets/agreementFiles/CIBC-French.pdf";

import NonBMOEnglish from "../assets/agreementFiles/NonBMO-English.pdf";
import NonBMOFrench from "../assets/agreementFiles/NonBMO-French.pdf";

//import BillPayEnglish from "../assets/agreementFiles/BillPayPortal-English.pdf";
//import BillPayFrench from "../assets/agreementFiles/BillPayPortal-French.pdf";
import BillPayEnglish from "../assets/agreementFiles/BillpayPortal-TnC-EN.pdf";
import BillPayFrench from "../assets/agreementFiles/BillpayPortal-TnC-FR.pdf";

import moment from "moment";
import { isBillerUserAndPortalType } from "./bpportal-common-utils";
import { BILLPAY_PORTAL_DISPLAYNAME, Regex } from "../constants/sharedConstants";

export const getComponentAccess = (module, loginUser) => {
  var menuGroup = loginUser.role.modules.find(m => m.componentType === module.label_type_code);
  var menuItem = menuGroup?.childComponents?.find(c => c.componentType === module.function_type_code);
  return menuItem?.childComponents || [];
};
const minTwoDigits = (n) => (n < 10 ? "0" : "") + n;

const getDateInStringFormat = (format, fileDate) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentDate = fileDate ? new Date(fileDate) : new Date();
  const year = currentDate.getFullYear();
  const month = minTwoDigits(currentDate.getMonth() + 1);
  const date = minTwoDigits(currentDate.getDate());
  const monthName = monthNames[month - 1];
  if (format === "DDMMYYYY") {
    return `${date}${month}${year}`;
  } else if (format === "YYYYMMDD") {
    return `${year}${month}${date}`;
  } else if ("MmmYYYY") {
    return `${monthName}${year}`;
  }
};

export const getFileNameToDownload = (page, roleId, data) => {
  let fileDate = "";
  if (data?.file_date) {
    fileDate = data?.file_date;
  } else if (data?.reportDate) {
    fileDate = data?.reportDate;
  }
  if (page === "report") {
    const webportalRoles = [1, 2, 3, 4];
    if (webportalRoles.includes(roleId)) {
      const fileName = data?.reportDescription || data?.file_type;
      const parsedFileName =
        fileName && fileName.includes("NBCAU ")
          ? fileName?.replace("NBCAU ", "")
          : fileName;

      let updatedFileName = parsedFileName?.replaceAll(" ", "_");
      const fileFormat =
        data?.downloaded_file_format?.toLowerCase() === "pdf" ? "pdf" : "csv";
      if (
        fileName.includes("Monthly") ||
        fileName?.trim() === "Biller Exception Report" ||
        fileName?.trim() === "Monthly Billing Volume File"
      ) {
        updatedFileName = `${updatedFileName}-${getDateInStringFormat(
          "MmmYYYY",
          fileDate
        )}.${fileFormat}`;
      } else {
        updatedFileName = `${updatedFileName}-${getDateInStringFormat(
          "DDMMYYYY",
          fileDate
        )}.${fileFormat}`;
      }
      return updatedFileName;
    } else {
      const fileName = data?.reportName;
      const fileType = data?.downloaded_file_format?.toLowerCase();
      const fileFormat =
        fileType === "pdf" ? "pdf" : fileType === "txt" ? "txt" : "csv";
      const updatedFileName = `${fileName}_${getDateInStringFormat(
        "YYYYMMDD",
        fileDate
      )}.${fileFormat}`;
      return updatedFileName;
    }
  } else {
    let fileName = data.file_type;
    const fileNumber =
      fileName && fileName !== "Service Fee Invoice" ? data?.file_number : "";
    const fileFormat = data?.fileFormat === "PDF" ? "pdf" : "csv";
    let updatedFileName = fileName?.replaceAll(" ", "_");
    updatedFileName = fileNumber
      ? `${updatedFileName}_${getDateInStringFormat(
          "YYYYMMDD",
          fileDate
        )}_${fileNumber}.${fileFormat}`
      : `${updatedFileName}_${getDateInStringFormat(
          "YYYYMMDD",
          fileDate
        )}.${fileFormat}`;
    return updatedFileName;
  }
};

export function API_BASE_URL() {
  if (process.env.REACT_APP_ENV === "dev")
    return store.getState()?.appConfigReducer.data?.API_BASE_URL + "/rest";
  return "/rest";
}

export const getErrorMessageFromException = (error, translation) => {
  const errorResponse = error?.response?.data;
  if (errorResponse) {
    const statusCode = errorResponse?.statusCode;

    if (statusCode) {
      return t("erps.error.code.500");  // "System Error. Please try again later"
    }
  }
  return getExceptionMessage(error);
};

export const customErrorAddBillerUser = (error) => {
  const errorStatus = error?.response?.status;
  if (errorStatus == 500 && !error?.response?.data?.timestamp) {
    return error?.response?.data;
  }
  return getExceptionMessage(error);
};

export const getExceptionMessage = (error, blobErrorObject) => {
  const statusCode = error.response?.status;
  const errorRes = error?.response?.data;

  let errorObj = blobErrorObject || errorRes;
  // if it's a standard ErrorResponse/ApiResponse message (in use from May 2025) :
  if (errorObj?.timestamp && errorObj?.showDetails != null) {
    let errorMessage = getMessageByCode(errorObj);
    return errorMessage || errorObj;
  }

  if (statusCode == 403)
    return t("erps.error.code.403");
  if (statusCode == 404)
    return t("erps.error.code.404");

  // Also OLD way of passing an error:  when status is 500 and errorRes (i.e. error.response.data) is a string containing the error message
  if (statusCode == 500 && (typeof errorRes === "string")) {
    return errorRes;
  }

  // Below is old error processing (prior to May 2025). It should ultimately be removed.

  // if (errorRes.error)
  //   return errorRes.error;

  let errorMessage = null;
  if (statusCode >= 500) {
    if(errorRes.statusCode === 504){   // This corresponded to @ExceptionHandler(IllegalArgumentException.class)    WHY????
      errorMessage = t("erps.transactionEnquiry.search.failed");
    } else if (errorRes?.message) {
      errorMessage = errorRes.message;
    // } else {
    //   errorMessage = t("erps.error.code.network");
    }
  } else if (statusCode == 400) {
    if (errorRes?.error_description) {
      errorMessage = errorRes?.error_description;
    } else if (errorRes.title) {
      errorMessage = t("erps.error.systemError") + "  Status 400. " + errorRes.title + " - " + errorRes.detail;
    }
  } else if (statusCode == 401) {
    if (errorRes?.error == "invalid_token")
      errorMessage = t("erps.error.message.sessionexpired");
    else if (errorRes?.error_description)
      errorMessage = errorRes?.error_description;
    else
      errorMessage = t("erps.error.message.accessdenied");
  }
  return errorMessage;
};

export const getMessageByCode = (responseObj) => {
  switch (responseObj?.responseCode) {
    // Success Messages
    case 21:  return t("erps.billermanagement.message.createSuccessful", {"billerFiNumber": responseObj.params?.billerFiNumber || "(n/a)"});
    case 22:  return t("erps.billermanagement.message.pendingAdd", {"billerQueueId": responseObj.params?.billerQueueId || "(n/a)"});
    case 23:  return t("erps.billermanagement.message.pendingUpdate", {"billerId": responseObj.params?.billerId || "(n/a)"});
    case 24:  return t("erps.billermanagement.message.updateSuccessful", {"billerId": responseObj.params?.billerId || "(n/a)"});

    // Error Messages
    case 1001:  return t("erps.rejectpaymentmerchants.page.lable.notbmobillerID", {"fi": responseObj.params?.fi || "(n/a)"});
    case 1002:  return t("erps.rejectpaymentmerchants.page.lable.notbmobillerName", {"fi": responseObj.params?.fi || "(n/a)"});
    case 1004:  return t("erps.transactionEnquiry.search.failed");
    case 1005:  return t("erps.common.errorMessage.fileDownloadFailed");
    case 1006:  return t("erps.rejectpaymentmerchants.message.paymentAlreadyRejected");
    case 1007:  return t("erps.rejectpaymentmerchants.message.rejectionNotAuthorizedByPayorFI");
    case 1008:  return t("erps.billermanagement.error.useridlength", {"length": responseObj.params?.length || "(n/a)"});
    case 1009:  return t("erps.billermanagement.error.billerNotFound");
    case 1010:  return t("erps.billermanagement.error.billerInactiveContactFIAdmin");
    case 1011:  return t("erps.billermanagement.error.pendingQueue", {"billerId": responseObj.params?.billerId || "(n/a)"});
    case 1012:  return t("erps.billermanagement.error.selectionIdNotexist");
    case 1013:  return t("erps.billermanagement.error.billerGroupError");
    case 1014:  return t("erps.billermanagement.error.updateNotAllowed");
    case 1015:  return t("erps.billermanagement.error.updateFailed");
    case 1016:  return t("erps.billermanagement.error.billerIdAlreadyExists");
    case 1017:  return t("erps.billermanagement.error.addFailed", {"billerQueueId": responseObj.params?.billerQueueId || "(n/a)"});
    default:    return null;
  }
}

/**
 * @param {{ useBillPayPortalAgreement?: boolean }} [options] - When useBillPayPortalAgreement is true, use the same
 *   static Bill Pay portal PDFs as the bill pay portal (not webportal FI-specific agreements), regardless of
 *   localStorage portal type. Useful when an admin views a biller cross-reference profile.
 */
export const getServiceAgreement = (user, options = {}) => {
  const useBillPayPortalAgreement = options.useBillPayPortalAgreement === true;
  const isWebPortal = !useBillPayPortalAgreement && "webportal" == localStorage.getItem("type");
  let agreementIdentifiers, additionalIdentifiers;
  
  if (user) {
    const isBillPayPortalWithBillerUser = useBillPayPortalAgreement ? true : isBillerUserAndPortalType(user, "billpay");

    const { fiNumber = 99, searchBillerFilesDto, creditorFiNumber } = user;
    const updatedCreditorFiNumber = creditorFiNumber || searchBillerFilesDto?.creditor_fi_number;

    const serviceNameIdentifiers = getAgreementServiceNames(isBillPayPortalWithBillerUser, fiNumber);
    let billpayPortalAgreementIdentifiers = { english: BillPayEnglish, french: BillPayFrench, fileName: '' };

    if(isWebPortal) {
      if (fiNumber === 99 && updatedCreditorFiNumber) {
        additionalIdentifiers = updatedCreditorFiNumber === 1 
                                  ? { english: BMOEnglish, french: BMOFrench, fileName: "BMO" } 
                                  : { english: NonBMOEnglish, french: NonBMOFrench, fileName: "BMO" }
      } else if (fiNumber === 2) {
        additionalIdentifiers =  { english: BNSEnglish, french: BNSFrench, fileName: "BNS" }
      } else if (fiNumber === 10) {
        additionalIdentifiers = { english: CIBCEnglish, french: CIBCFrench, fileName: "CIBC" } 
      }
    } else {
      additionalIdentifiers = billpayPortalAgreementIdentifiers;
    }

    agreementIdentifiers = {...serviceNameIdentifiers, ...additionalIdentifiers};
  }

  return agreementIdentifiers;
};

const getAgreementServiceNames = (isBillPayPortalWithBillerUser, fiNumber) => {
  let serviceName = t("erps.app.title.message.billpay", "CANACT Billpay Portal");
  let profileUpdateSubmsg = t("erps.welcome.page.accountsettings.billpay.portal.profile.update.submsg", "if required");

  let referrerServiceName = getReferrerServiceName(fiNumber);

  if(!isBillPayPortalWithBillerUser){
    serviceName = referrerServiceName;
    profileUpdateSubmsg = t("erps.welcome.page.accountsettings.remittance.portal.profile.update.submsg", ", and change your password");
  }

  return { serviceName, referrerServiceName, profileUpdateSubmsg };
}

const getReferrerServiceName = (fiNumber) => {
  return fiNumber == 99 ? t("erps.app.title.message.bmo", "Merchant Bill Pay Service")
                        : t("erps.app.title.message", "Bill payment remittance reporting");
}

export const getFormatDetails = (data) => {
  if (data) {
    const updateValue = typeof data !== "string" ? data.toString() : data;
    return `(${updateValue.slice(0, 3)}) ${updateValue.slice(
      3,
      6
    )}-${updateValue.slice(6)}`;
  }
};

export const getFormattedPhoneNumber = (phone) => {
  if (phone) {
    const updatedString = typeof phone !== "string" ? phone.toString() : phone;
    const formattedPhoneNumber = `${updatedString.slice(
      0,
      3
    )}-${updatedString.slice(3, 6)}-${updatedString.slice(6)}`;
    return formattedPhoneNumber;
  }
  return "";
};

export const getNextFilterId = (
  filteredQueueDataList,
  requiredArr,
  userId,
  key
) => {
  let nextFilteredId = "";
  if (requiredArr && requiredArr.length) {
    let nextIndexVal = requiredArr.findIndex(
      ({ updatedBy }) => userId !== updatedBy || userId == updatedBy
    );
    if (nextIndexVal === -1) {
      if (filteredQueueDataList && filteredQueueDataList.length) {
        nextIndexVal = filteredQueueDataList.findIndex(
          ({ updatedBy }) => userId !== updatedBy || userId == updatedBy
        );
        if (nextIndexVal !== -1) {
          nextFilteredId = filteredQueueDataList[nextIndexVal]?.[key];
        }
      }
    } else {
      nextFilteredId = requiredArr[nextIndexVal]?.[key];
    }
  }
  return nextFilteredId;
};

export var lpad = (number, length) => {
  var str = "" + number;
  if (str.length < length) str = new Array(length - str.length).join("0") + str;
  return str;
};

export const formatDate = (dateValue) => {
  if (dateValue) {
    const d = dateValue;
    if (typeof d === "string") {
      return d.split("T")[0]?.replaceAll("-", "");
    } else {
      return d.toISOString()?.split("T")[0]?.replaceAll("-", "");
    }
  }
};

export const requiredFormatDate = (d) => {
  if (d) {
    const splittedDate = d.split("/");
    if (splittedDate && splittedDate.length) {
      let [date, month, year] = splittedDate;
      if (year.split(" ")) {
        year = year.split(" ")[0];
      }
      return `${year}-${month}-${date}`;
    }
  }
};

export const statisticsFormatDate = (d) => {
  if (d) {
    return moment(d, "YYYYMMDD").format("YYYY-MM-DD");
  }
};

export const formatDateTime = (d, pattern) => {
  return d ? moment(d).format(pattern || "YYYY-MM-DD hh:mm:ss") : "";
};

export const formatUTCDate = (d, pattern) => {
  return d && typeof d === "string" ? moment(d + "Z").format(pattern || "YYYY-MM-DD") : "";
};

export const formatUTCDateTime = (d, pattern) => {
  // IS "YYYY-MM-DD h:mmA" THE BEST FORMAT TO USE BY DEFAULT ???
  return d && typeof d === "string" ? moment(d + "Z").format(pattern || "YYYY-MM-DD h:mmA") : "";
};

export const convertDateStringIntoERPSDateFormat = (dateStr) => {
  if (dateStr) {
    var date = formatDate(dateStr);
    if (date) {
      return date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
    }
  }
};

export const convertDateIntoERPSDateFormat = (date) => {
  if (date) {
    return date.toString()?.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
  }
};

export const getDateFromString = (d) => {
  if (d && typeof d === "number") {
    const parsedValue = d.toString();

    if (parsedValue && parsedValue.length) {
      const formattedDate = `${parsedValue.slice(0, 4)}/${parsedValue.slice(
        4,
        6
      )}/${parsedValue.slice(6)}`;
      const date = new Date(formattedDate);
      return date;
    }
  }
};

export const formatDateOrReplace = (dateString, formatString, replaceEmptyValue = "", replaceInvalidValue = "") => {
    if (!dateString)
      return replaceEmptyValue;
    const m = moment(dateString);
    return m.isValid() ? m.format(formatString) : replaceInvalidValue;
  };

export const formatIntDate = (date) => {  // Argument must be a number or a string of 8 characters long
  let d = (typeof date === "string") ? date : String(date);
  return (d.length == 8) ? d.slice(0,4) + "-" + d.slice(4,6) + "-" + d.slice(6) : "";
}

export const formatIntTime = (time) => { // Argument must be a number or a string.
  let t = (typeof time === "number") ? String(time) : time;
  t = t.slice(0, 6).padStart(6, "0");  //  "12345678" > "123456",  "12" > "000012"
  return t.slice(0,2) + ":" + t.slice(2,4) + ":" + t.slice(4);
}
  
export const roleConfigUrls = {
  1: "/manage-billers",
  2: "/manage-billers",
  3: "/dashboard",
  4: "/dashboard",
  5: "/manage-billers",
  6: "/manage-users",
  8: "/review-transactions",
  9: "/review-transactions",
  10: "/manage-billers",
  11: "/manage-users",
  12: "/manage-billers",
};

let USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatAmount = (amount) => {
  return USDollar.format(amount);
};

export const zeroPad = (num, places) => {
  if (num) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  } else {
    return "";
  }
};
export const validateURL = (link) => {
  const res = link.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9@:%_\+.~#?&=\/,;'"]*/g
  );
  return res !== null;
};

const hasUndefined = (val) => {
  return val === undefined;
};

const hasArray = (arr) => {
  return !hasUndefined(arr) && Array.isArray(arr);
};
const hasObject = (obj) => {
  return (
    !hasUndefined(obj) &&
    typeof obj === "object" &&
    !Array.isArray(obj) &&
    obj !== null
  );
};
const hasStringValue = (val) => {
  return !hasUndefined(val) && val !== null && typeof val === "string";
};
const hasNumericValue = (val) => {
  return !hasUndefined(val) && typeof val === "number" && !isNaN(val);
};
const hasBooleanValue = (val) => {
  return !hasUndefined(val) && typeof val == "boolean";
};

const hasNullType = (val) => {
  return !hasUndefined(val) && typeof val == "object" && val === null;
};

const compareTwoArrayOfObjects = (
  first_array_of_objects,
  second_array_of_objects
) => {
  return (
    first_array_of_objects.length === second_array_of_objects.length &&
    first_array_of_objects.every((element_1) =>
      second_array_of_objects.some((element_2) =>
        Object.keys(element_1).every((key) => element_1[key] === element_2[key])
      )
    )
  );
};

const hasEmptyValue = (val) => {
  return val === undefined || val === "";
};
const checkObjectValueChange = (preObj, postObj) => {
  let hasNotChanged = true;
  for (let keyObj in preObj) {
    if (!hasObject(preObj[keyObj])) {
      if (preObj[keyObj] !== postObj[keyObj]) {
        hasNotChanged = false;
        return;
      }
    } else {
      return checkObjectValueChange(preObj[keyObj], postObj[keyObj]);
    }
  }
  return hasNotChanged;
};

const checkArrayValueChange = (prevArr, currArr) => {
  const hasNotChanged = compareTwoArrayOfObjects(prevArr, currArr);
  return hasNotChanged;
};

const checkValueChanged = (oldData, newData, k) => {
  let hasValueChanged = false;
  if (hasArray(newData) && hasArray(oldData)) {
    hasValueChanged = checkArrayValueChange(oldData, newData);
  } else if (hasObject(oldData) && hasObject(newData)) {
    hasValueChanged = checkObjectValueChange(oldData, newData);
  } else if (hasStringValue(oldData) && hasStringValue(newData)) {
    const hasStringValueSame = oldData === newData;
    hasValueChanged = hasStringValueSame;
  } else if (hasNumericValue(oldData) && hasNumericValue(newData)) {
    hasValueChanged = oldData === newData;
  } else if (hasBooleanValue(oldData) && hasBooleanValue(newData)) {
    hasValueChanged = oldData === newData;
  } else if (hasNullType(oldData) && hasNullType(newData)) {
    hasValueChanged = oldData == newData;
  } else if (hasNullType(oldData) && hasStringValue(newData)) {
    hasValueChanged = oldData == newData;
  } else {
    return hasNullType(oldData) || hasEmptyValue(oldData);
  }
  return hasValueChanged;
};

export const checkFieldsChange = (pre, post) => {
  if (hasObject(pre) && hasObject(post)) {
    const postKeys = Object.keys(post);
    return postKeys.some((objKey) => {
      const val = checkValueChanged(pre[objKey], post[objKey], objKey);
      return !val;
    });
  }
  return false;
};
export const getLabelName = (data) => {
  const { key, hasLastActiveRecord, lastRecordDisable, t } = data;
  if (key === "decline") {
    return hasLastActiveRecord() || lastRecordDisable
      ? t("erps.common.button.reject")
      : t("erps.updatebillerapproval.button.rejectandgonext");
  } else if (key == "approve") {
    return hasLastActiveRecord() || lastRecordDisable
      ? t("erps.common.button.approve")
      : t("erps.updatebillerapproval.button.approveandgonext");
  }
  return "";
};

export const getBillerGroupErrorMessage = (message) => {
  if (message) {
    if (message === "ERPS0055") {
      return [t("erps.billermanagement.error.selectionIdNotexist")];
    } else if (message === "HSBCDUP") {
      return [t("erps.billermanagement.error.billerIdAlreadyExists")];
    }
  }

  return [];
};

export const sanitizeQueryParams = (jsonObj) => {
  let updatedReqBody = {};
  Object.keys(jsonObj)
    .filter(key => jsonObj[key] !== undefined)  //  shouldn't we also add   != null   ??
    .forEach((key) => {
      if (typeof jsonObj[key] !== "string")
        updatedReqBody[key] = jsonObj[key];
      else if (jsonObj[key].trim() !== "")
        updatedReqBody[key] = jsonObj[key].trim();
    });
  return updatedReqBody;
};

export function maxCharOccurrence(str, char, maxTimes) {
  return  str?.split(char)?.length <= maxTimes + 1;
}

export function checkLengthAndRegex(value, fieldLabel, length = 0, regex = null) {
  let errorMsg;
  if (length > 0 && value.length > length) {
      errorMsg = valueTooLongError(fieldLabel, length);
  } else if (regex && !regex.test(value)) {
      const invalidChar = [...value].find(char => !regex.test(char));
      errorMsg = invalidChar
          ? t("erps.common.errorMessage.invalidCharacter", { character: invalidChar })
          : t("erps.common.errorMessage.field.invalidCharacters", { fieldLabel: t(fieldLabel  || "(missing field label)") }) ;
    } else {
      errorMsg = "";
    }
    return errorMsg;
}

export function checkFieldValue(value, fieldLabel, isRequired, validityCheck, maxLength) {
  let isString = (typeof value === "string");
  let isEmpty = !value || (isString && value.trim() === "");
  if (isRequired && isEmpty)
    return requiredFieldError(fieldLabel);
  if (!isEmpty) {
    if (validityCheck) {
      if (validityCheck.validator === true) {
        if (!validityCheck.test(value))
          return validityCheck.error(fieldLabel)
      } else {
        if (!validityCheck(value))
          return invalidFieldError(fieldLabel);
      }
    }
    if (isString && maxLength && value.length > maxLength)
      return t("erps.common.errorMessage.notLongerThan", {fieldLabel: t(fieldLabel || "(missing field label)"), maxLength});
  }
  return "";  // value is valid
}

export function requiredFieldError(fieldLabel) {
  return t("erps.common.errorMessage.field.required", {fieldLabel: t(fieldLabel || "(missing field label)")});
}
export function invalidFieldError(fieldLabel) {
  return t("erps.common.errorMessage.field.invalid", {fieldLabel: t(fieldLabel || "(missing field label)")});
}
export function valueTooLongError(fieldLabel, maxLength) {
  return t("erps.common.errorMessage.field.tooLong",
           {fieldLabel: t(fieldLabel || "(missing field label)"), maxLength: maxLength});
}

export function setFinancialInstitutionUIData(fiReducerList, setFiMap, setFiList, valueForAllFIs, languageCode, allBmoFisLabel) {
  if (fiReducerList?.length > 0) {
    const isFrench = languageCode && languageCode.toUpperCase() === 'F';
    
    if (setFiMap) {
      setFiMap(new Map(fiReducerList.map(fi => {
        const frenchName = fi.fi_french_name;
        const englishName = fi.fi_name;
        const displayName = (isFrench && frenchName) ? frenchName : englishName;
        return [fi.fi_number, displayName];
      })));
    }
    if (setFiList) {
      const fiList = fiReducerList.map(fi => {
        const frenchName = fi.fi_french_name;
        const englishName = fi.fi_name;
        const fiName = (isFrench && frenchName) ? frenchName : englishName;
        return { value: fi.fi_number, label: `${fi.fi_number} - ${fiName}` };
      });

      const label = allBmoFisLabel || "erps.common.label.allFis";
      fiList.unshift({value: (valueForAllFIs == null ? "0" : valueForAllFIs), label: t(label)});
      setFiList(fiList);
    }
  }
}

export function isBigFI(fiNumber) {
  return fiNumber <= 10 || fiNumber == 99;
}

/** This function returns a comma-separated list of an object's properties.
 * If 'withValues' is true, then property values are also included.
 * If 'withValues' is an array of property names, then property values are included only for the listed properties.
 * If 'depth' is 0, includes the values of the current object only,
 * if 'depth' is 1, in addition to above, if a property is itself an object, then will include its properties also. */
export const listProps = (obj, withValues = false, depth = 0) => {
  if (obj === undefined)  return "undefined";
  if (obj === null)  return "null";
  if (typeof obj === "string")  return '"' + obj + '"';
  var s = "";
  if (withValues) {
    if (Array.isArray(withValues)) {
      for (var key of withValues) {
        var keySplit = key.trim().split(":");
        s += "," + (key.charAt(0) == " " ? "\n " : " ") + keySplit[0] + "=" + propValue(obj[keySplit[0]], depth, keySplit[1]);
      }
    } else {
      for (var key in obj)  s += ", " + key + "=" + propValue(obj[key], depth);
    }
  } else {
    for (var key in obj)  s += ", " + key;
  }
  return s.substring(2);
};

export function propValue(prop, depth, childProps) {
  if (prop === null)
    return "null";
  if (Array.isArray(prop))
    return "[" + prop.length+" " + (typeof prop) + "(s)]";
  if (typeof prop == "string")
    return '"' + prop + '"';
  if (typeof prop == "function") {
    let s = prop.toString();
    return s.substring(0, s.indexOf("function") + 8);
  }
  if (typeof prop == "object") {
    if (childProps)
      return "{" + listProps(prop, childProps.split(","), depth-1) + "}";
    else if (depth > 0)
      return "{" + listProps(prop, true, depth-1) + "}";
  }
  return prop;
}

export function listInfo(list, attrs) {
  if (!list)  return list;
  let len = list.length;
  if (len === undefined || len === null)
    return "(not a list) " + list;
  let result = "size=" + list.length;
  if (list.length > 0) {
    if (!attrs) {
        result += " - [" + list.join(", ") + "]";
    } else if (attrs === true) {
      result += " - [" + list.map(e => "{" + listProps(e, true) + "}").join(", ") + "]";
    } else if (typeof attrs === "string") {
      result += " - [" + list.map(e => e[attrs]).join(", ") + "]";
    } else if (Array.isArray(attrs)) {
      if (attrs.length == 1)
        result += " - [" + list.map(e => e[attrs[0]]).join(", ") + "]";
      else
        result += " - [" + list.map(e => "{" +  attrs.map(a => e[a]).join() + "}").join(", ") + "]";
    }
  }
  return result;
}

/**
 * Maps status code to display value
 * @param {string} statusCode - The status code (A, I, R, N)
 * @returns {string} The translated status display value
 */
export const getStatusDisplayValue = (statusCode) => {
  switch (statusCode) {
    case "A":
      return t("erps.manageusers.label.status.active");
    case "I":
      return t("erps.manageusers.label.status.inactive");
    case "R":
      return t("erps.manageusers.label.status.locked");
    case "N":
      return t("erps.manageusers.label.status.new");
    default:
      return t("erps.manageusers.label.status.inactive"); // Default to inactive for unknown statuses
  }
};

/** Return true if value contains only digits */
export const isValueNumericOnly = (value) => {
  return /^[0-9]+$/.test(value.toString());
};

export const GEN_H6_EDI_FORMAT = "H6 3030";

/** Summary distribution format values, keyed by delivery method. */
export const SUMMARY_DELIVERY_FORMATS = {
  FAX: ["TOT FAX"],
  EMAIL: ["TOT EMAIL"],
};

const isAllowedCoexistingDeliveryRow = (m) =>
  Boolean(
    m?.deliveryMethod &&
      SUMMARY_DELIVERY_FORMATS[m.deliveryMethod]?.includes(
        m.distributionFormat
      )
  );

/**
 * EDI Gen H6 cannot be combined with any other delivery method, so no further
 * delivery method can be added while any row is EDI Gen H6.
 */
export const isAddDeliveryMethodAllowed = ({initialDeliveryMethods, deliveryMethods = [],}) =>
  ![initialDeliveryMethods, ...deliveryMethods].some(
    (m) =>
      m?.deliveryMethod === "EDI" && m?.distributionFormat === GEN_H6_EDI_FORMAT
  );

/**
 * - EDI Gen H6 (format "H6 3030") cannot be combined with any other method.
 * - EDI Non Gen H6 can only coexist with FAX (Summary Fax) and/or
 *   EMAIL (Summary Email) delivery methods.
 *
 * Returns the list of error messages and whether the delivery method field
 * should be highlighted. Returns no errors for FIs other than 50.
 */
export const validateDeliveryMethods = ({initialDeliveryMethods, deliveryMethods = [],
  t,}) => {
  const errors = [];
  let highlightDeliveryMethod = false;

  const distributionRows = [initialDeliveryMethods, ...deliveryMethods].filter(
    (m) => m?.deliveryMethod
  );

  const hasEdiGenH6 = distributionRows.some(
    (m) =>
      m.deliveryMethod === "EDI" && m.distributionFormat === GEN_H6_EDI_FORMAT
  );

  if (hasEdiGenH6 && distributionRows.length > 1) {
    errors.push(t("erps.billermanagement.error.ediGenH6ExclusiveDeliveryMethod"));
    highlightDeliveryMethod = true;
    return { errors, highlightDeliveryMethod };
  }

  const hasEdiNonGenH6 = distributionRows.some(
    (m) =>
      m.deliveryMethod === "EDI" &&
      m.distributionFormat &&
      m.distributionFormat !== GEN_H6_EDI_FORMAT
  );

  if (hasEdiNonGenH6) {
    const ediRows = distributionRows.filter((m) => m.deliveryMethod === "EDI");
    const nonEdiRows = distributionRows.filter(
      (m) => m.deliveryMethod !== "EDI"
    );
    const ediNonH6CoexistInvalid =
      ediRows.length > 1 ||
      nonEdiRows.some(
        (m) => !isAllowedCoexistingDeliveryRow(m)
      );
    if (ediNonH6CoexistInvalid) {
      errors.push(t("erps.billermanagement.error.ediGenH6CoexistFaxSummaryOnly"));
      highlightDeliveryMethod = true;
    }
  }

  return { errors, highlightDeliveryMethod };
};

/**
 * Validates EMAIL delivery method distribution list codes against the email
 * regex for both the initial delivery method and any additional delivery
 * methods.
 *
 * Returns the list of error messages and a highlight object describing which
 * distribution list code field should be highlighted.
 */
export const validateEmailDeliveryMethods = ({initialDeliveryMethods, deliveryMethods = [], t,}) => {
  const errors = [];
  const highlight = {};

  const isInvalidEmail = (value) => value && !Regex.email.test(value);

  const hasInvalidInitialEmail =
    initialDeliveryMethods?.deliveryMethod === "EMAIL" &&
    isInvalidEmail(initialDeliveryMethods?.distributionListCode);

  const hasInvalidOtherEmail =
    deliveryMethods.length > 0 &&
    deliveryMethods.some(
      ({ distributionListCode, deliveryMethod }) =>
        deliveryMethod === "EMAIL" && isInvalidEmail(distributionListCode)
    );

  if (hasInvalidInitialEmail || hasInvalidOtherEmail) {
    if (hasInvalidInitialEmail) {
      highlight.initialDistributionListCode = true;
    } else {
      highlight.distributionListCode = true;
    }
    errors.push(t("erps.billermanagement.error.invalidEmailDestination"));
  }

  return { errors, highlight };
};